export default __webpack_public_path__ + "static/media/massup_s1.36546f6f.png";